import { getOperationName } from '@apollo/client/utilities';

import { MyOrders_PublishedOfferingsDocument } from '../../../../../../my-orders/graphql/__generated__';
import { useCrmSelection_AssignCoveredInvestorKeyMutation } from '../graphql/__generated__';

export const refetchQueries = () => {
  return [getOperationName(MyOrders_PublishedOfferingsDocument)!];
};

export const useAssignCoveredInvestorKeyMutation = () => {
  return useCrmSelection_AssignCoveredInvestorKeyMutation({
    awaitRefetchQueries: true,
    refetchQueries,
  });
};
